import StyledHeading from '/shared/styled/components/StyledHeading';
import StyledParagraph from '/shared/styled/components/StyledParagraph';
import ElectricityHeatSteamEmissionsDisplay from '/business/shared/components/questions/scope2/_education/ElectricityHeatSteamEmissionsDisplay';

export const BottomCertsPage = (
  <>
    <div className="hse-landingbtm">
      <StyledHeading as="h2" $type="h1" $hasExtraBottomMargin $hasSuperTopMargin>
        Inputting energy attribute certificates data
      </StyledHeading>
      <StyledParagraph $largeText>
        An <b>Energy Attribute Certificate (EAC)</b> is a tradable certificate that confirms that one megawatt-hour
        (MWh) of electricity was generated from a specific source, typically renewable energy
      </StyledParagraph>
      <StyledParagraph $largeText>
        EACs serve as proof that renewable energy has been produced and injected into the grid, allowing organisations
        and individuals to claim the associated benefits, such as reduced greenhouse gas emissions, without physically
        consuming the electricity from that source.
      </StyledParagraph>
      <StyledParagraph $largeText>
        EACs are an umbrella term covering regional and international schemes, including:
      </StyledParagraph>
      <ul>
        <li>
          <StyledParagraph $largeText>
            <b>Renewable Energy Certificates (RECs)</b> in North America
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            <b>Guarantees of Origin (GOs)</b> in Europe
          </StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>
            <b>International RECs (I-RECs)</b> in global markets
          </StyledParagraph>
        </li>
      </ul>
      <StyledParagraph $largeText>
        <b>Certificate details may include:</b>
      </StyledParagraph>
      <ul>
        <li>
          <StyledParagraph $largeText>Total kWh covered by the certificate</StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>Remaining kWh available</StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>kWh allocated for this carbon review</StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>Supplier carbon intensity (e.g. kg CO₂e/kWh)</StyledParagraph>
        </li>
        <li>
          <StyledParagraph $largeText>Certificate validity period</StyledParagraph>
        </li>
      </ul>
      <ElectricityHeatSteamEmissionsDisplay />
    </div>
  </>
);
